import { z } from "zod";

/**
 * PRTL-1487: a free-text value read from a URL search param (`?search=…`).
 *
 * TanStack Router JSON-parses every search value, so a hand-edited or bookmarked
 * `?search=2024` arrives as the number 2024 (and `?search=true` as a boolean).
 * A plain `z.string()` then fails route validation and the page renders the error
 * screen. This reads numbers and booleans back as text and drops anything that is
 * not text at all (null, objects, arrays) instead of throwing.
 *
 * Use it in route `validateSearch` schemas, not in tRPC inputs: the client always
 * sends the parsed string.
 */
export const UrlSearchText = z
    .union([z.string(), z.number(), z.boolean()])
    .transform((value) => String(value))
    .optional()
    .catch(undefined);
